// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: atk/calibration.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "carbon.atk";

export interface TractorCalibrationConfig {
  path: string;
  int64Val?: number | undefined;
  uint64Val?: number | undefined;
  boolVal?: boolean | undefined;
  floatVal?: number | undefined;
  stringVal?: string | undefined;
}

/**
 * ////////////////////////////////////////////////////////////////////////////
 * GPS
 * ////////////////////////////////////////////////////////////////////////////
 */
export interface TractorCalibration {
  /**
   * the x position of the center of the tractor front axle relative to the main
   * GPS antenna.  (positive = the antenna is port of the tractor centerline.)
   */
  gpsPosXMm: number;
  /**
   * the y position of the center of the tractor front axle relative to the main
   * GPS antenna.  (positive = the antenna is aft of the front axle.)
   */
  gpsPosYMm: number;
  /**
   * the angle between the GPS heading and the heading of the nose of the
   * tractor.  (positive = the nose of the tractor is clockwise of the GPS
   * heading.)
   */
  gpsHeadingOffsetDeg: number;
  /**
   * center trim; when the commanded steering position is this many degrees
   * right of center, the tractor is going straight.
   */
  steeringCenterTrimDeg: number;
  /** left valve deadband current in milliamps. */
  steeringLeftDeadbandMa: number;
  /** right valve deadband current in milliamps. */
  steeringRightDeadbandMa: number;
  /** steering valve minimum current in milliamps. */
  steeringControlSignalMinMa: number;
  /** steering valve maximum current in milliamps. */
  steeringControlSignalMaxMa: number;
  /**
   * not all of the bringup calibration parameters have been given their own
   * fields in the calibration object yet.  the robot software should also
   * overwrite any configs in extra_configs with the provided values; the paths
   * in the configs should be filtered to a small set of allowable overwritable
   * trees, but the robot should only ignore and warn about disallowed paths
   * rather than becoming inoperable, to allow for graceful deprecation.
   */
  extraConfigs: TractorCalibrationConfig[];
}

/**
 * ////////////////////////////////////////////////////////////////////////////
 * GPS
 * ////////////////////////////////////////////////////////////////////////////
 */
export interface ImplementCalibration {
  /**
   * the x position of the implement hitch point relative to the main GPS
   * antenna.  (positive = the antenna is port of the hitch point.)
   */
  gpsPosXMm: number;
  /**
   * the y position of the implement hitch point relative to the main GPS
   * antenna.  (positive = the antenna is aft of the hitch point.)
   */
  gpsPosYMm: number;
  /**
   * the angle between the GPS heading and the heading of the nose of the
   * tractor.  (positive = the hitch point is clockwise of the GPS heading.)
   */
  gpsHeadingOffsetDeg: number;
}

function createBaseTractorCalibrationConfig(): TractorCalibrationConfig {
  return {
    path: "",
    int64Val: undefined,
    uint64Val: undefined,
    boolVal: undefined,
    floatVal: undefined,
    stringVal: undefined,
  };
}

export const TractorCalibrationConfig: MessageFns<TractorCalibrationConfig> = {
  encode(message: TractorCalibrationConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== "") {
      writer.uint32(10).string(message.path);
    }
    if (message.int64Val !== undefined) {
      writer.uint32(16).int64(message.int64Val);
    }
    if (message.uint64Val !== undefined) {
      writer.uint32(24).uint64(message.uint64Val);
    }
    if (message.boolVal !== undefined) {
      writer.uint32(32).bool(message.boolVal);
    }
    if (message.floatVal !== undefined) {
      writer.uint32(41).double(message.floatVal);
    }
    if (message.stringVal !== undefined) {
      writer.uint32(50).string(message.stringVal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TractorCalibrationConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractorCalibrationConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.int64Val = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.uint64Val = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.boolVal = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.floatVal = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.stringVal = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TractorCalibrationConfig {
    return {
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      int64Val: isSet(object.int64Val)
        ? globalThis.Number(object.int64Val)
        : isSet(object.int64_val)
        ? globalThis.Number(object.int64_val)
        : undefined,
      uint64Val: isSet(object.uint64Val)
        ? globalThis.Number(object.uint64Val)
        : isSet(object.uint64_val)
        ? globalThis.Number(object.uint64_val)
        : undefined,
      boolVal: isSet(object.boolVal)
        ? globalThis.Boolean(object.boolVal)
        : isSet(object.bool_val)
        ? globalThis.Boolean(object.bool_val)
        : undefined,
      floatVal: isSet(object.floatVal)
        ? globalThis.Number(object.floatVal)
        : isSet(object.float_val)
        ? globalThis.Number(object.float_val)
        : undefined,
      stringVal: isSet(object.stringVal)
        ? globalThis.String(object.stringVal)
        : isSet(object.string_val)
        ? globalThis.String(object.string_val)
        : undefined,
    };
  },

  toJSON(message: TractorCalibrationConfig): unknown {
    const obj: any = {};
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.int64Val !== undefined) {
      obj.int64Val = Math.round(message.int64Val);
    }
    if (message.uint64Val !== undefined) {
      obj.uint64Val = Math.round(message.uint64Val);
    }
    if (message.boolVal !== undefined) {
      obj.boolVal = message.boolVal;
    }
    if (message.floatVal !== undefined) {
      obj.floatVal = message.floatVal;
    }
    if (message.stringVal !== undefined) {
      obj.stringVal = message.stringVal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TractorCalibrationConfig>, I>>(base?: I): TractorCalibrationConfig {
    return TractorCalibrationConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TractorCalibrationConfig>, I>>(object: I): TractorCalibrationConfig {
    const message = createBaseTractorCalibrationConfig();
    message.path = object.path ?? "";
    message.int64Val = object.int64Val ?? undefined;
    message.uint64Val = object.uint64Val ?? undefined;
    message.boolVal = object.boolVal ?? undefined;
    message.floatVal = object.floatVal ?? undefined;
    message.stringVal = object.stringVal ?? undefined;
    return message;
  },
};

function createBaseTractorCalibration(): TractorCalibration {
  return {
    gpsPosXMm: 0,
    gpsPosYMm: 0,
    gpsHeadingOffsetDeg: 0,
    steeringCenterTrimDeg: 0,
    steeringLeftDeadbandMa: 0,
    steeringRightDeadbandMa: 0,
    steeringControlSignalMinMa: 0,
    steeringControlSignalMaxMa: 0,
    extraConfigs: [],
  };
}

export const TractorCalibration: MessageFns<TractorCalibration> = {
  encode(message: TractorCalibration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gpsPosXMm !== 0) {
      writer.uint32(9).double(message.gpsPosXMm);
    }
    if (message.gpsPosYMm !== 0) {
      writer.uint32(17).double(message.gpsPosYMm);
    }
    if (message.gpsHeadingOffsetDeg !== 0) {
      writer.uint32(25).double(message.gpsHeadingOffsetDeg);
    }
    if (message.steeringCenterTrimDeg !== 0) {
      writer.uint32(33).double(message.steeringCenterTrimDeg);
    }
    if (message.steeringLeftDeadbandMa !== 0) {
      writer.uint32(41).double(message.steeringLeftDeadbandMa);
    }
    if (message.steeringRightDeadbandMa !== 0) {
      writer.uint32(49).double(message.steeringRightDeadbandMa);
    }
    if (message.steeringControlSignalMinMa !== 0) {
      writer.uint32(57).double(message.steeringControlSignalMinMa);
    }
    if (message.steeringControlSignalMaxMa !== 0) {
      writer.uint32(65).double(message.steeringControlSignalMaxMa);
    }
    for (const v of message.extraConfigs) {
      TractorCalibrationConfig.encode(v!, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TractorCalibration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTractorCalibration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.gpsPosXMm = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.gpsPosYMm = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.gpsHeadingOffsetDeg = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.steeringCenterTrimDeg = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.steeringLeftDeadbandMa = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.steeringRightDeadbandMa = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.steeringControlSignalMinMa = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.steeringControlSignalMaxMa = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.extraConfigs.push(TractorCalibrationConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TractorCalibration {
    return {
      gpsPosXMm: isSet(object.gpsPosXMm)
        ? globalThis.Number(object.gpsPosXMm)
        : isSet(object.gps_pos_x_mm)
        ? globalThis.Number(object.gps_pos_x_mm)
        : 0,
      gpsPosYMm: isSet(object.gpsPosYMm)
        ? globalThis.Number(object.gpsPosYMm)
        : isSet(object.gps_pos_y_mm)
        ? globalThis.Number(object.gps_pos_y_mm)
        : 0,
      gpsHeadingOffsetDeg: isSet(object.gpsHeadingOffsetDeg)
        ? globalThis.Number(object.gpsHeadingOffsetDeg)
        : isSet(object.gps_heading_offset_deg)
        ? globalThis.Number(object.gps_heading_offset_deg)
        : 0,
      steeringCenterTrimDeg: isSet(object.steeringCenterTrimDeg)
        ? globalThis.Number(object.steeringCenterTrimDeg)
        : isSet(object.steering_center_trim_deg)
        ? globalThis.Number(object.steering_center_trim_deg)
        : 0,
      steeringLeftDeadbandMa: isSet(object.steeringLeftDeadbandMa)
        ? globalThis.Number(object.steeringLeftDeadbandMa)
        : isSet(object.steering_left_deadband_ma)
        ? globalThis.Number(object.steering_left_deadband_ma)
        : 0,
      steeringRightDeadbandMa: isSet(object.steeringRightDeadbandMa)
        ? globalThis.Number(object.steeringRightDeadbandMa)
        : isSet(object.steering_right_deadband_ma)
        ? globalThis.Number(object.steering_right_deadband_ma)
        : 0,
      steeringControlSignalMinMa: isSet(object.steeringControlSignalMinMa)
        ? globalThis.Number(object.steeringControlSignalMinMa)
        : isSet(object.steering_control_signal_min_ma)
        ? globalThis.Number(object.steering_control_signal_min_ma)
        : 0,
      steeringControlSignalMaxMa: isSet(object.steeringControlSignalMaxMa)
        ? globalThis.Number(object.steeringControlSignalMaxMa)
        : isSet(object.steering_control_signal_max_ma)
        ? globalThis.Number(object.steering_control_signal_max_ma)
        : 0,
      extraConfigs: globalThis.Array.isArray(object?.extraConfigs)
        ? object.extraConfigs.map((e: any) => TractorCalibrationConfig.fromJSON(e))
        : globalThis.Array.isArray(object?.extra_configs)
        ? object.extra_configs.map((e: any) => TractorCalibrationConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TractorCalibration): unknown {
    const obj: any = {};
    if (message.gpsPosXMm !== 0) {
      obj.gpsPosXMm = message.gpsPosXMm;
    }
    if (message.gpsPosYMm !== 0) {
      obj.gpsPosYMm = message.gpsPosYMm;
    }
    if (message.gpsHeadingOffsetDeg !== 0) {
      obj.gpsHeadingOffsetDeg = message.gpsHeadingOffsetDeg;
    }
    if (message.steeringCenterTrimDeg !== 0) {
      obj.steeringCenterTrimDeg = message.steeringCenterTrimDeg;
    }
    if (message.steeringLeftDeadbandMa !== 0) {
      obj.steeringLeftDeadbandMa = message.steeringLeftDeadbandMa;
    }
    if (message.steeringRightDeadbandMa !== 0) {
      obj.steeringRightDeadbandMa = message.steeringRightDeadbandMa;
    }
    if (message.steeringControlSignalMinMa !== 0) {
      obj.steeringControlSignalMinMa = message.steeringControlSignalMinMa;
    }
    if (message.steeringControlSignalMaxMa !== 0) {
      obj.steeringControlSignalMaxMa = message.steeringControlSignalMaxMa;
    }
    if (message.extraConfigs?.length) {
      obj.extraConfigs = message.extraConfigs.map((e) => TractorCalibrationConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TractorCalibration>, I>>(base?: I): TractorCalibration {
    return TractorCalibration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TractorCalibration>, I>>(object: I): TractorCalibration {
    const message = createBaseTractorCalibration();
    message.gpsPosXMm = object.gpsPosXMm ?? 0;
    message.gpsPosYMm = object.gpsPosYMm ?? 0;
    message.gpsHeadingOffsetDeg = object.gpsHeadingOffsetDeg ?? 0;
    message.steeringCenterTrimDeg = object.steeringCenterTrimDeg ?? 0;
    message.steeringLeftDeadbandMa = object.steeringLeftDeadbandMa ?? 0;
    message.steeringRightDeadbandMa = object.steeringRightDeadbandMa ?? 0;
    message.steeringControlSignalMinMa = object.steeringControlSignalMinMa ?? 0;
    message.steeringControlSignalMaxMa = object.steeringControlSignalMaxMa ?? 0;
    message.extraConfigs = object.extraConfigs?.map((e) => TractorCalibrationConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseImplementCalibration(): ImplementCalibration {
  return { gpsPosXMm: 0, gpsPosYMm: 0, gpsHeadingOffsetDeg: 0 };
}

export const ImplementCalibration: MessageFns<ImplementCalibration> = {
  encode(message: ImplementCalibration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gpsPosXMm !== 0) {
      writer.uint32(9).double(message.gpsPosXMm);
    }
    if (message.gpsPosYMm !== 0) {
      writer.uint32(17).double(message.gpsPosYMm);
    }
    if (message.gpsHeadingOffsetDeg !== 0) {
      writer.uint32(25).double(message.gpsHeadingOffsetDeg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImplementCalibration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImplementCalibration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.gpsPosXMm = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.gpsPosYMm = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.gpsHeadingOffsetDeg = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImplementCalibration {
    return {
      gpsPosXMm: isSet(object.gpsPosXMm)
        ? globalThis.Number(object.gpsPosXMm)
        : isSet(object.gps_pos_x_mm)
        ? globalThis.Number(object.gps_pos_x_mm)
        : 0,
      gpsPosYMm: isSet(object.gpsPosYMm)
        ? globalThis.Number(object.gpsPosYMm)
        : isSet(object.gps_pos_y_mm)
        ? globalThis.Number(object.gps_pos_y_mm)
        : 0,
      gpsHeadingOffsetDeg: isSet(object.gpsHeadingOffsetDeg)
        ? globalThis.Number(object.gpsHeadingOffsetDeg)
        : isSet(object.gps_heading_offset_deg)
        ? globalThis.Number(object.gps_heading_offset_deg)
        : 0,
    };
  },

  toJSON(message: ImplementCalibration): unknown {
    const obj: any = {};
    if (message.gpsPosXMm !== 0) {
      obj.gpsPosXMm = message.gpsPosXMm;
    }
    if (message.gpsPosYMm !== 0) {
      obj.gpsPosYMm = message.gpsPosYMm;
    }
    if (message.gpsHeadingOffsetDeg !== 0) {
      obj.gpsHeadingOffsetDeg = message.gpsHeadingOffsetDeg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImplementCalibration>, I>>(base?: I): ImplementCalibration {
    return ImplementCalibration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImplementCalibration>, I>>(object: I): ImplementCalibration {
    const message = createBaseImplementCalibration();
    message.gpsPosXMm = object.gpsPosXMm ?? 0;
    message.gpsPosYMm = object.gpsPosYMm ?? 0;
    message.gpsHeadingOffsetDeg = object.gpsHeadingOffsetDeg ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
